const linkedInPosterSwedish = {
  messages: {
    connectionError: "Ett fel uppstod vid kontroll av dina anslutningar",
    codeGenerationError: "Ett fel uppstod vid generering av anslutningskod. Försök igen senare.",
    workflowTestSuccess: "LinkedIn-inlägg skickat via Telegram! Kolla din Telegram-chatt.",
    workflowTestError: "Fel vid testning av arbetsflöde. Kontrollera konsolen för detaljer.",
    linkedInDisconnectError: "Ett fel uppstod vid frånkoppling av LinkedIn: {message}",
    telegramDisconnectError: "Ett fel uppstod vid frånkoppling av Telegram: {message}",
    deliveryPreferenceError: "Ett fel uppstod vid inställning av leveranspreferens: {message}"
  }
};

export default linkedInPosterSwedish; 